/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import superagent from "superagent";
import Cookies from "universal-cookie";
import {
  GET_BLOGS_SEARCH_DATA,
  GET_FORMS_SEARCH_DATA,
  GET_RESOURCE_SEARCH_DATA,
  GET_SEARCH_DATA,
  GET_TOOLBOX_SEARCH_DATA,
  SET_SEARCH_LOADER,
} from "./constants";
import { base_url } from "../../../utils/constants";

const cookie = new Cookies();

function setData(dispatch: any, data: any) {
  dispatch({
    type: GET_SEARCH_DATA,
    payload: data,
  });
  dispatch({
    type: GET_BLOGS_SEARCH_DATA,
    payload: data.blogs,
  });
  dispatch({
    type: GET_RESOURCE_SEARCH_DATA,
    payload: data.resources,
  });
  dispatch({
    type: GET_TOOLBOX_SEARCH_DATA,
    payload: data.tool_boxes,
  });
  dispatch({
    type: GET_FORMS_SEARCH_DATA,
    payload: data.forms,
  });
  dispatch({ type: SET_SEARCH_LOADER, payload: false });
}

export const getSearchData = (value: any) => (dispatch: any) => {
  try {
    dispatch({ type: SET_SEARCH_LOADER, payload: true });
    return superagent
      .get(`${base_url}search?searchKeyword=${value}`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((_err, res) => {
        if (res?.body?.data) {
          setData(dispatch, res?.body?.data);
        }
        if (_err) {
          dispatch({ type: SET_SEARCH_LOADER, payload: false });
        }
      });
  } catch (error) {
    dispatch({
      type: GET_SEARCH_DATA,
      payload: {},
    });
    dispatch({
      type: GET_BLOGS_SEARCH_DATA,
      payload: [],
    });
    dispatch({
      type: GET_RESOURCE_SEARCH_DATA,
      payload: [],
    });
    dispatch({
      type: GET_TOOLBOX_SEARCH_DATA,
      payload: [],
    });
    dispatch({
      type: GET_FORMS_SEARCH_DATA,
      payload: [],
    });
    dispatch({ type: SET_SEARCH_LOADER, payload: false });
    console.error("error from search", error);
  }
};

// eslint-disable-next-line sonarjs/no-identical-functions
export const getAuthSearchData = (value: any) => (dispatch: any) => {
  try {
    dispatch({ type: SET_SEARCH_LOADER, payload: true });
    return superagent
      .get(`${base_url}auth-search?searchKeyword=${value}`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((_err, res) => {
        if (res?.body?.data) {
          setData(dispatch, res?.body?.data);
        }
        if (_err) {
          dispatch({ type: SET_SEARCH_LOADER, payload: false });
        }
      });
  } catch (error) {
    dispatch({
      type: GET_SEARCH_DATA,
      payload: {},
    });
    dispatch({
      type: GET_BLOGS_SEARCH_DATA,
      payload: [],
    });
    dispatch({
      type: GET_RESOURCE_SEARCH_DATA,
      payload: [],
    });
    dispatch({
      type: GET_TOOLBOX_SEARCH_DATA,
      payload: [],
    });
    dispatch({
      type: GET_FORMS_SEARCH_DATA,
      payload: [],
    });
    dispatch({ type: SET_SEARCH_LOADER, payload: false });
    console.error("error from search", error);
  }
};
